import React from 'react';
import { DownloadIcon, LockIcon, MonitorSmartphoneIcon, ZapIcon } from 'lucide-react';
import { securityItems } from '../../data/landing';
import { GoldSeal } from '../GoldSeal';
const icons = [LockIcon, ZapIcon, MonitorSmartphoneIcon, DownloadIcon];
export function SecuritySection() {
  return <section className="bg-sage-100 py-10 sm:py-20" data-id="element-330" data-mp="vga9dlkqt1nx">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-331" data-mp="vfiekcyyz7yp">
        <div className="flex items-center gap-4 md:gap-14" data-id="element-332" data-mp="19ft2b74zg6fn">
          <div className="md:hidden" data-id="element-333" data-mp="19e89pn28axkf">
            <GoldSeal size={96} lines={['7 días de', 'garantía']} caption="Compra segura" data-id="element-334" data-mp="14i9p8ak0tzpa" />
          </div>
          <div className="hidden md:block" data-id="element-335" data-mp="1j5coalnzsgeq">
            <GoldSeal size={160} lines={['7 días de', 'garantía']} caption="Compra segura" data-id="element-336" data-mp="1j88lu8vxh32n" />
          </div>
          <div className="w-full" data-id="element-337" data-mp="1s72drlybd59v">
            <h2 className="font-serif text-2xl leading-tight text-petrol-800 sm:text-4xl" data-id="element-338" data-mp="1s6aw7f1jx82l">Comprá con total tranquilidad</h2>
            <p className="mt-2 text-sm leading-relaxed text-ink/70 sm:text-base" data-id="element-339" data-mp="1o71zq2f4mw3c">
              Tenés <strong className="text-petrol-800" data-id="element-340" data-mp="1q8209dvgp5bb">7 días de garantía</strong> desde tu compra para revisar todo el
              material con calma.
            </p>
            <ul className="mt-8 hidden gap-x-8 gap-y-5 md:grid md:grid-cols-2" data-id="element-341" data-mp="1z7oqr4mnkqpl">
              {securityItems.map((item, i) => <SecurityItem key={item} item={item} index={i} data-id="element-342" data-mp="246ry4vq3v90q" data-mpi={i} />)}
            </ul>
          </div>
        </div>
        <ul className="mt-5 grid grid-cols-2 gap-2 md:hidden" data-id="element-343" data-mp="294jovmf0kp3c">
          {securityItems.map((item, i) => <SecurityItem key={item} item={item} index={i} compact data-id="element-344" data-mp="2d6eo8lddwseh" data-mpi={i} />)}
        </ul>
      </div>
    </section>;
}
function SecurityItem({
  item,
  index,
  compact = false
}: {
  item: string;
  index: number;
  compact?: boolean;
}) {
  const Icon = icons[index];
  return <li className={`flex items-center font-medium text-petrol-800 ${compact ? 'gap-2 rounded-xl bg-paper/70 p-3 text-[13px] leading-snug' : 'gap-3'}`} data-id="element-345" data-mp="2rw2rvt91g35d">
      <Icon className={`shrink-0 text-petrol-700 ${compact ? 'h-4 w-4' : 'h-5 w-5'}`} aria-hidden="true" data-id="element-346" data-mp="2wvywnupk7ylz" />
      {item}
    </li>;
}